export const roundToTwoDecimal = (price: number): string => {
  return (Math.round((price + Number.EPSILON) * 100) / 100).toFixed(2);
};

export const financial = (price: string, currency: string) => {
  return `${roundToTwoDecimal(Number.parseFloat(price))} ${currency}`;
};
